export { CollapseMenuComponent } from './collapse-menu.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/collapse-menu/index.ts